import { routes } from '@/app/routing/router'
import { TransactionHistoryView } from './view'
const currentRoute = routes.transactionHistory

const TransactionHistoryRoute = {
  route: currentRoute,
  view: TransactionHistoryView,
}

export { currentRoute, TransactionHistoryRoute }
